import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys, projectQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useUpdateProjectsBatchMutation = (options) => {
  const handleMutation = async ({ projectIds = [], body }) => {
    const occurred = new Date().toISOString()

    const responses = await Promise.all(
      projectIds.map((projectId) =>
        api(`/api/projects/${projectId}`, {
          method: 'patch',
          data: {
            ...body,
            occurred
          }
        })
      )
    )

    return responses.map(({ data }) => data)
  }

  const invalidateRelatedQueries = (projectIds) => {
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_MY_PROJECTS_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_LIMIT_QUERY]
    })

    projectIds.forEach((projectId) => {
      customQueryClient.invalidateQueries({
        queryKey: [projectQueryKeys.GET_PROJECT_QUERY, projectId]
      })
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [projectMutationKeys.UPDATE_PROJECTS_BATCH_MUTATION],
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries(variables.projectIds)
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}
